import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NonSessionComponent } from './component';
import { AdmissionPageComponent } from './admission-page/admission-page';
import { SiliconAdmissionPageComponent } from './silicon-admission-page/silicon-admission-page';

const routes: Routes = [
  {
    path: '', component: NonSessionComponent,
    children: [
      {
        path: 'admission-page', component: AdmissionPageComponent
      }, {
        path: 'landing-page', loadChildren: "./landing-page/module#LandingPageModule"
      }, {
        path: 'registration', loadChildren: "./registration/module#RegistrationModule"
      }, {
        path: 'silicon-admission-page', component: SiliconAdmissionPageComponent
      },
      {
        path: 'forgot-password', loadChildren: "./forgot-password/module#ForgotPasswordModule"
      },
      {
        path: 'parent-login', loadChildren: "./parent-login/module#ParentLoginModule"
      },
      {
        path: 'online-payment', loadChildren: "./online-payment/module#OnlinePaymentModule"
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RoutingModule {
}
